import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import robiImage from '../../assets/images/robi-sidebar-help.webp';
import { ButtonLink } from '../ui/Button';
import './layout.css';

export function SidebarRobiCard() {
  const { t } = useTranslation();

  return (
    <section
      className="side-nav__robi-card"
      aria-labelledby="side-nav-robi-card-title"
    >
      <img className="side-nav__robi-image" src={robiImage} alt="" aria-hidden />
      <div className="side-nav__robi-content">
        <div className="side-nav__robi-text">
          <h2 id="side-nav-robi-card-title" className="side-nav__robi-title">
            {t('sidebar.robiCard.title')}
          </h2>
          <p className="side-nav__robi-description">
            {t('sidebar.robiCard.description')}
          </p>
        </div>
        <ButtonLink to="/?robi=quick-answer" size="sm" className="side-nav__robi-action">
          {t('sidebar.robiCard.action')}
        </ButtonLink>
      </div>
    </section>
  );
}
